<template>
  <form-field-select
    :label="label"
    :value="value"
    @change="handleInput"
    :validation-errors="validationErrors"
    :help-text="helpText"
  >
    <option
        v-for="option in ENUMS.TemperatureEnum"
        :key="option.value"
        :value="option.value"
    >{{option.label}}</option>
  </form-field-select>
</template>

<script>
import FormField from "./FormField";
import {FormFieldMixin} from "./FormField.mixin";

export default {
  name: "FormFieldSelectTemperature",
  components: {FormField},
  mixins: [FormFieldMixin],
  props: {
    value: {},
    label: {
      type: String,
      default: "Temperature"
    },
    validationErrors: {
      type: [
        String,
        Array,
        undefined
      ]
    },
    helpText: {
      type: String
    },
    size: {
      type: String,
      default: "is-small"
    },
    hasEmptyOption: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {},
  methods: {
    handleInput(val) {
      this.$emit("input", val);
      this.$emit("change", val);
      this.$emit("selected", val);

      this.emitGlobalFieldChangeEvent();
    },
  }
};
</script>

<style lang="scss" scoped>
// Due to how Buefy works these styles must be in global styles
</style>
